import { useLayoutEffect } from 'react';
import { redirect, useSearchParams } from 'react-router-dom';
import { useAuthState } from 'state/client-middleware';
import { ResetpasswordForm } from 'features/auth/components/reset-password';
import { useMobileDeepLink } from 'hooks/use-mobile-deep-link';
import { MobileDeepLinkLoader } from 'components/core/mobile-deep-link-loader';
import { useTranslation } from 'react-i18next';
import { KlaxWelcome } from 'components/blocks/klax-welcome';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') ?? '';
  const { isMounted, isAuthenticated } = useAuthState();
  const { t } = useTranslation();

  const deepLinkUrl = `${process.env.REACT_APP_PUBLIC_MOBILE_BUNDLE_ID}://reset-password/?code=${code}`;
  const { shouldShowFallback, isAttemptingDeepLink, isMobile } = useMobileDeepLink({
    deepLinkUrl,
    fallbackDelay: 2000,
  });

  useLayoutEffect(() => {
    if (isAuthenticated) redirect('/');
  }, [isAuthenticated]);

  if (!isMounted) return null;

  if (isMobile && isAttemptingDeepLink && !shouldShowFallback) {
    return <MobileDeepLinkLoader />;
  }

  return (
    <div className="mb-4 flex w-full flex-col gap-6">
      <KlaxWelcome title={t('RESET_PASSWORD')} />
      <div className="flex gap-1">
        <div className="text-sm font-normal text-medium-emphasis">
          {t('CHOOSE_PASSWORD_SECURE_ACCOUNT')}
        </div>
      </div>

      <ResetpasswordForm code={code} />
    </div>
  );
}
